// extracted by css-extract-rspack-plugin
export default {"notification":"notification--fc299x0z_E4zcV3Q","content":"content--VCZBAUnDGoh4ZanK","close":"close--wRxSNZIe9R4StyPm"};